<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <!-- {{profileArr}} -->
                  <div class="col-sm-12">
                    <h3 class="page-title">Faq - Affiliate Program</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <faq />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
// import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import LayoutSidebarPromotion from "@/components/layouts/Sidebar.vue";

import Faq from "./components/faq.vue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
    Faq
  },
  computed: {
    memberSession() {
      return this.$store.state.login.memberSession;
    }
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      isLoading: false
    };
  },
  async created() {},
  methods: {
    join() {
      this.isLoading = true;
      this.$store
        .dispatch("referral/join")
        .then(response => {
          this.isLoading = false;
          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000
          });
          this.$router.push({ path: "/" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "referral"
};
</script>


// WEBPACK FOOTER //
// src/views/referral/faq.vue